export const TransactionTypeList = [
  { value: "pos", label: "Point of Sale (POS)" },
  { value: "transfer", label: "Bank Transfer" },
  { value: "cash", label: "Cash" },
  { value: null, label: "" },
];
